import React from "react";
import { Helmet } from "react-helmet";
import HeaderDefault from "../../../components/header/HeaderDefault";
import CopyRight from "../../../components/footer/copyright/CopyRight";
import Footer from "../../../components/footer/Footer";
import ServiceList from "../../../components/list/ServiceList";
import ServiceFaq from "../../../components/faq/ServiceFaq";
import Skills from "../../../components/skill/Skills";
import CounterThree from "../../../components/counter/CounterThree";
import CloudApproach from "../../../components/service/CloudApproach";
import CloudProcess from "../../../components/service/CloudProcess";
import ImageGridTwo from "../../../components/image-grid/ImageGridTwo";


const CloudService = () => {
    return (
        <div>
            <Helmet>
                <title>Multi Cloud Ai - Cloud Develeopment</title>
            </Helmet>
            {/* End Page SEO Content */}

            <HeaderDefault />
            {/* End Header */}

            <div className="ptf-main">
                <div className="ptf-page ptf-page--service-detail">
                    <section>

                        <div className="container-xxl">
                            <div className="row">
                                <div className="col-xl-9">
                                    {/* <!--Animated Block--> */}

                                </div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                                    ></div>
                                    <h1 className="large-heading2 text-center"
                                    >Cloud App Development</h1>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        Cloud app development that helps to build cloud apps that run in the cloud
                                        environment may hold cloud features and many other services offered by cloud
                                        platforms. In cloud computing services, Multi Cloud Ai quick and reliable
                                        is delivering cloud native application development and cloud-only
                                        apps that efficiently employ all cloud capabilities. </p>

                                    <ImageGridTwo />

                                </div>
                                {/* <!--Spacer--> */}
                                <div
                                    className="ptf-spacer"
                                    style={{ "--ptf-xxl": "5rem" }}
                                ></div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    <h3>Benefits Of Cloud App Development Services By Multi Cloud Ai</h3>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "2.5rem" }}
                                    ></div>
                                    <h4>Optimized monthly cloud costs and performance</h4>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "1.5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        We design optimal resource orchestration patterns (including autoscaling
                                        for load surges in peak times), select particular cloud services    best-suited for your specific case, and
                                        establish performance testing procedures.</p>
                                </div>
                                {/* <!--Spacer--> */}
                                <div
                                    className="ptf-spacer"
                                    style={{ "--ptf-xxl": "5rem" }}
                                ></div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    <h4>High development speed</h4>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "1.5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        We help you organize effective DevOps and continuous code delivery
                                        environment and help you select ready-to-go cloud services that you can use in the development of your app
                                        instead of writing own code.</p>
                                </div>
                                {/* <!--Spacer--> */}
                                <div
                                    className="ptf-spacer"
                                    style={{ "--ptf-xxl": "5rem" }}
                                ></div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    <h4>Enhanced security</h4>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "1.5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        We advocate the use of encryption as well as the use of access- and
                                        component-level security to prevent cyberthreats.</p>
                                </div>
                                {/* <!--Spacer--> */}
                                <div
                                    className="ptf-spacer"
                                    style={{ "--ptf-xxl": "5rem" }}
                                ></div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    <h4>Reduced migration cost</h4>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "1.5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        We design individual pragmatic strategies for each application and data
                                        warehouse to avoid re-development efforts and thus cut down on migration costs.</p>
                                </div>
                                {/* <!--Spacer--> */}
                                <div
                                    className="ptf-spacer"
                                    style={{ "--ptf-xxl": "5rem" }}
                                ></div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    <h4>Reliability and recovery </h4>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "1.5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        We design fault-tolerant architectures for your cloud apps as well as
                                        recommend APM (Application Performance Management) practices to ensure high app reliability and fast
                                        recovery..</p>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* Top Portion */}


                    <div
                        className="ptf-animated-block"
                        data-aos="fade"
                        data-aos-delay="0"
                    >
                    </div>
                    <div
                        className="ptf-spacer"
                        style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                    ></div>
                    <section
                        className="has-accent-1-background"
                        style={{
                            backgroundImage: `url("/assets/img/root/service-bubble.png")`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "100% calc(100% + 120px)",
                        }}
                    >
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                        ></div>
                        <div className="container-xxl">
                            {/* <!--Animated Block--> */}
                            <div
                                className="ptf-animated-block"
                                data-aos="fade"
                                data-aos-delay="1"
                            >
                                <h1 className="has-white-color large-heading">Scope Of Our Cloud Services</h1>

                            </div>
                            {/* <!--Spacer--> */}
                            <div
                                className="ptf-spacer"
                                style={{ "--ptf-xxl": "7.5rem", "--ptf-md": " 3.75rem" }}
                            ></div>
                            <CloudApproach />
                        </div>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "10rem", "--ptf-md": "5rem" }}
                        ></div>
                    </section>

                    <section>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "5.625rem", "--ptf-md": "2.8125rem" }}
                        ></div>
                        <div className="container-xxl">
                            <div className="row">
                                <div className="col-xl-8">
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h2>How We Build Our Cloud Apps?</h2>
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "4.375rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>Scalable and Compatible apps</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                        <p className="fz-18 my_background">
                                            We do have many modules to scale up and check its compatibility
                                            with many devices and other tools before making in production. We also use load balancer for heavy
                                            traffic web portals, We reduce cost as well.
                                        </p>
                                    </div>

                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "4.375rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>Modifiable and compatible cloud apps</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                        <p className="fz-18 my_background ">
                                            We use an architecture which can be used with other tools and
                                            technology, we also make API's Documentations and give full access to source code.
                                        </p>
                                    </div>

                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "4.375rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>Cost-efficient cloud apps</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                        <p className="fz-18 my_background">
                                            Multi Cloud Ai always keeps in mind that we reduce cost for development and server costing with high
                                            scalable and log management.

                                        </p>
                                    </div>  {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "3.125rem" }}
                                    ></div>
                                    <div
                                        className="row"
                                        style={{
                                            "--bs-gutter-x": "3.75rem",
                                            "--bs-gutter-y": "7.5rem",
                                        }}
                                    >
                                        <CounterThree />
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "6.875rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h3>Our Skills</h3>
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "3.75rem" }}
                                    ></div>
                                    <div className="ptf-skill-box-grid">
                                        <Skills />
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "6.875rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h2>Our Working Process</h2>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>

                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5.625rem" }}
                                    ></div>
                                    {/* <!--Process Steps--> */}
                                    <CloudProcess />
                                </div>
                                <div className="col-xl-4">
                                    <div className="ptf-sidebar ptf-sidebar--right">
                                        {/* <!--Widget--> */}
                                        <div className="ptf-widget ptf-widget-services-list">
                                            {/* <!--Animated Block--> */}
                                            <div
                                                className="ptf-animated-block"
                                                data-aos="fade"
                                                data-aos-delay="0"
                                            >
                                                <h4 className="ptf-widget-title">Services List</h4>
                                                <ServiceList />
                                            </div>
                                        </div>
                                        {/* <!--Widget--> */}
                                        <div className="ptf-widget ptf-widget-faq">
                                            {/* <!--Animated Block--> */}
                                            <div
                                                className="ptf-animated-block"
                                                data-aos="fade"
                                                data-aos-delay="0"
                                            >
                                                <h4 className="ptf-widget-title">FAQs</h4>
                                                <ServiceFaq />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "6.25rem", "--ptf-md": "3.125rem" }}
                        ></div>
                    </section>
                    {/* End .main content with sidebar */}
                </div>
                {/* End .ptf-page */}
            </div>
            {/* End ptf-main */}

            {/*=============================================
        Start Footer
        ============================================== */}
            <footer className="ptf-footer ptf-footer--style-1">
                <div className="container-xxl">
                    <div className="ptf-footer__top">
                        <Footer />
                    </div>
                    <div className="ptf-footer__bottom">
                        <CopyRight />
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default CloudService;
